export default "__VITE_ASSET__Qxf$5lhp__"